import type { useDraggable } from '@dnd-kit/core'

interface ResizeHandleProps {
	position: 'top' | 'bottom'
	draggable: Pick<
		ReturnType<typeof useDraggable>,
		'setNodeRef' | 'transform' | 'attributes' | 'listeners'
	>
}

export const ResizeHandle = ({ position, draggable }: ResizeHandleProps) => {
	let knobClass = position === 'top' ? '-top-2 left-5' : 'right-5 -bottom-2'

	if (draggable.transform) {
		knobClass += ` scale-125`
	}

	return (
		<div
			ref={draggable.setNodeRef}
			{...draggable.attributes}
			{...draggable.listeners}
			className='h-2 cursor-ns-resize sm:h-[5px]'
		>
			<div
				className={`absolute z-10 size-3.5 rounded-full border border-primary bg-white transition-transform ${knobClass}`}
			/>
		</div>
	)
}
